import { render } from "./ChatList.vue?vue&type=template&id=52a03ad6&scoped=true"
import script from "./ChatList.vue?vue&type=script&lang=ts"
export * from "./ChatList.vue?vue&type=script&lang=ts"

import "./ChatList.vue?vue&type=style&index=0&id=52a03ad6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-52a03ad6"

export default script